import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { red } from '@material-ui/core/colors';
import withStyles from "@material-ui/core/styles/withStyles";
import * as PropTypes from "prop-types";
import {AddCircleOutlineTwoTone, Delete} from "@material-ui/icons";
import Modal from "@material-ui/core/Modal";
import RevisionModal from "./RevisionModal";
import moment from "moment";
import {BlueButton} from "../common/ButtonsConstants";
import * as CommonUtils from "../../util/CommonUtils";

const classes = () => ({
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: red[500],
        fontSize: 10,
    },
});

class DocumentControlHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            revision: this.props.revision,
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                revision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    render() {
        const { classes, organisation } = this.props;
        const { show, revision } = this.state;

        const isRevision = revision.author && revision.approvedBy;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Card className={classes.card}>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            disabled={isAuditor}
                            style={{marginRight: '10px'}}
                        >
                            ADD
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{revision.title}</b></p>
                            <p>{isRevision && `Revision ${revision.number} Author: ${revision.author}`}</p>
                        </span>
                    }
                    subheader={
                        isRevision &&
                        <span>
                            <p>Approved for suitability and adequacy by: {revision.approvedBy} on {moment(revision.date).format('DD/MM/YYYY')}</p>
                        </span>
                    }
                />
                <CardContent>
                    <hr/>
                    {this.props.children}
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={show}
                onClose={() => this.closeModal(null)}
            >
                <RevisionModal revision={revision} postSubmit={this.closeModal} organisation={organisation}/>
            </Modal>
        </div>
    }
}

DocumentControlHeader.propTypes = {
    revision: PropTypes.object.isRequired,
    organisation: PropTypes.object.isRequired,
};

export default withStyles(classes)(DocumentControlHeader);